import type { EntityConfigDefinition, DisplayColumnConfig, FilterConfig } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'SERVICE_RESPONSE',
  idField: 'SERVICE_RESPONSE_ID',
  
  // Data loading configuration
  loadServiceOptions: true,
  
  // Filtering configuration
  hasFilters: true,
  filterType: 'service',
  requiresServiceFilter: true,
  showEmptyUntilFiltered: true,
  
  // Custom filters for this entity
  customFilters: {
    service: {
      label: 'Filter by Service',
      field: 'SERVICE_ID',
      type: 'service',
      required: true,
      showAlways: true
    }
  },
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['SERVICE_RESPONSE_ID'],
  
  // Fields to remove before GraphQL mutations (SERVICE_RESPONSE table has no audit fields)
  fieldsToRemove: [],
  
  // SERVICE_RESPONSE shows filtered list by service, not optimized for single response details
  useOptimizedQuery: false,
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['SERVICE_ID', 'RESPONSE_PATH'],
    comparisonFields: ['SERVICE_ID', 'RESPONSE_PATH', 'DATA_TYPE', 'IS_SENSITIVE', 'STATUS_CODE_START', 'STATUS_CODE_END', 'DATA_ELEMENT_ID'],
    useDisplayValues: {
      'SERVICE_ID': 'URI',
      'DATA_ELEMENT_ID': 'ELEMENT_KEY'
    },
    displayFieldMapping: {
      'SERVICE_ID': 'URI',
      'DATA_ELEMENT_ID': 'ELEMENT_KEY'
    },
    requiresServiceFilter: true,
    showEmptyUntilFiltered: true,
    serviceFilterField: 'SERVICE_ID',
    displayFields: ['SERVICE_RESPONSE_ID', 'SERVICE_ID', 'RESPONSE_PATH', 'DATA_TYPE', 'IS_SENSITIVE', 'STATUS_CODE_START', 'STATUS_CODE_END', 'DATA_ELEMENT_ID'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Foreign key lookups for SQL generation
  foreignKeys: {
    "SERVICE_ID": {
      "table": "SERVICE",
      "valueField": "SERVICE_ID",
      "displayField": "URI"
    },
    "DATA_ELEMENT_ID": {
      "table": "DATA_ELEMENT",
      "valueField": "DATA_ELEMENT_ID",
      "displayField": "ELEMENT_KEY"
    }
  },
  
  // Field lookups for display enhancement
  fieldLookups: {
    "SERVICE_ID": {
      "lookupTable": "SERVICE",
      "foreignKey": "SERVICE_ID",
      "displayField": "URI",
      "displayFormat": "{SERVICE_ID}: {URI}"
    },
    "DATA_ELEMENT_ID": {
      "lookupTable": "DATA_ELEMENT",
      "foreignKey": "DATA_ELEMENT_ID",
      "displayField": "ELEMENT_KEY",
      "displayFormat": "{DATA_ELEMENT_ID}: {ELEMENT_KEY}"
    }
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'SERVICE_ID',
      lookup: {
        table: 'SERVICE',
        foreignKey: 'SERVICE_ID',
        displayField: 'URI'
      }
    },
    {
      field: 'DATA_ELEMENT_ID',
      lookup: {
        table: 'DATA_ELEMENT',
        foreignKey: 'DATA_ELEMENT_ID',
        displayField: 'ELEMENT_KEY'
      }
    }
  ] as DisplayColumnConfig[],

  // Unified filter configuration
  filters: {
    table: [
      { type: 'service', field: 'SERVICE_ID', label: 'Filter by Service', required: true }
    ] as FilterConfig[],
    requiresService: true,
    showEmptyUntilFiltered: true
  },

  // Fields configuration
  fields: [
    "SERVICE_RESPONSE_ID",
    "SERVICE_ID",
    "RESPONSE_PATH",
    "DATA_TYPE",
    "IS_SENSITIVE",
    "STATUS_CODE_START",
    "STATUS_CODE_END",
    "DATA_ELEMENT_ID"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "SERVICE_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "RESPONSE_PATH",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "DATA_TYPE",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "IS_SENSITIVE",
      "type": "checkbox",
      "required": false,
      "disabled": false
    },
    {
      "name": "STATUS_CODE_START",
      "type": "number",
      "required": true,
      "disabled": false
    },
    {
      "name": "STATUS_CODE_END",
      "type": "number",
      "required": true,
      "disabled": false
    },
    {
      "name": "DATA_ELEMENT_ID",
      "type": "select",
      "required": false,
      "disabled": false
    }
  ]
}

export default config

